import CertificatesList from './List';

export default CertificatesList; 